import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../i18n/translate"
import ClearFilterIcon from "../../../images/icons/clear.svg"
import Button from "../../button/button"
import { WalkThroughTooltip } from "../../walk-through-tooltip/walk-through-tooltip"
import { sortProductParameterGroups } from "../product-param-helpers"
import ProductFilter from "./product-filter/product-filter"
import "./product-filters.sass"

class ProductFilters extends React.Component {
  constructor(props) {
    super(props)

    const { productsDatabase } = props

    this.state = {
      filters: productsDatabase.getFilters(),
      hasFilters: false,
    }
  }

  componentDidMount() {
    this.setState({
      hasFilters: this.props.productsDatabase.hasFilters(),
      initialStateRestored:
        this.props.productsDatabase.isInitialStateRestored(),
    })
    this.productsSub = this.props.productsDatabase.onUpdate(() => {
      this.setState({
        filters: this.props.productsDatabase.getFilters(),
        hasFilters: this.props.productsDatabase.hasFilters(),
        initialStateRestored:
          this.state.initialStateRestored &&
          this.props.productsDatabase.hasFilters(),
      })
    })
  }

  componentWillUnmount() {
    this.productsSub.unsubscribe()
  }

  render() {
    const { t } = this.props
    const { filters, hasFilters, initialStateRestored } = this.state

    return (
      <div className="_fp-product-filter">
        <WalkThroughTooltip
          shown={initialStateRestored}
          message={t("PRODUCTS-PRODUCT_FILTERS-FILTERS-RESTORED")}
        >
          <Button
            buttonCallback={() => {
              this.props.productsDatabase.resetFilters()
            }}
            buttonSize={"small"}
            buttonSvgIconComponent={<ClearFilterIcon />}
            buttonStyle={hasFilters ? "blue-soft" : "disabled"}
            buttonLabel={t("PRODUCTS-PRODUCT_FILTERS-RESET_ALL_FILTERS")}
          />
        </WalkThroughTooltip>

        {sortProductParameterGroups(
          [].concat(
            filters.ENUM,
            filters.EFFECT,
            filters.NUMBER,
            filters.RANGE,
            filters.DUAL_NUMBER,
            filters.BOOLEAN,
          ),
          t,
        ).map((filter, index) => (
          <ProductFilter
            key={`product-filter-${index}`}
            productFilter={filter}
            reset={() => {
              filter.externalReset()
            }}
          />
        ))}
      </div>
    )
  }
}

ProductFilters.propTypes = {
  productsDatabase: PropTypes.object.isRequired,
}

export default withTranslation()(ProductFilters)
